module.exports = __webpack_public_path__ + "static/media/reg.1ed07757.svg";